<!-- eslint-disable -->
<script setup>
import { useI18n } from 'vue-i18n';
import { useRegisterStore } from '../../stores/register';
import { useRegistrationDocumentTypesStore } from '../../stores/registration_documents_types';

const { t } = useI18n();
const registerStore = useRegisterStore();
const documentTypeStore = useRegistrationDocumentTypesStore();
</script>

<template>
	<div class="register-form-field">
		<label>{{$t('account.register.document_type')}}</label>
		<select @change="registerStore.validateDocumentIDType" name="" v-model="registerStore.register_input_fields.registration_document_id_type" class="form-input form-control" id="address-country">
			<option :value="null" disabled>{{ $t('account.register.choose_document_type') }}</option>
			<option v-for="registration_documents_type in documentTypeStore.getRegistrationDocumentTypes" :key="registration_documents_type.id" :value="registration_documents_type.id">{{ registration_documents_type.name }}</option>
		</select>
		<div class="register-form-list" v-if="registerStore.register_errors.registration_document_id_type.error">
			<div class="password-meter">
				<div class="password-meter-bar">
					<div class="password-meter-bar-inn"></div>
				</div>
			</div>
			<p>
				<img src="@/assets/svgs/cross.svg" alt=""/>
				&nbsp;
				<span v-if="registerStore.register_errors.registration_document_id_type.error === 'error_select_registration_document_id'">
					{{ $t('account.register.error_select_document_type') }}
				</span>
				<span v-else-if="registerStore.register_errors.hasOwnProperty('registration_document_id_type')">
					{{ registerStore.register_errors.registration_document_id_type.error }}
				</span>
			</p>
		</div>
	</div>
</template>

<style scoped>
.register-form-main .register-outer-form .register-inner-form .password-meter .password-meter-bar {
	background-color:var(--red);
	margin-bottom:5px;
}
.register-form-main .register-form-list {
	margin-top:unset;
	padding-top:5px;
}
html[dir="rtl"] .register-form-main .register-outer-form .register-inner-form select {
	background-position: 5%;
}
html[dir="rtl"] .register-form-main .register-outer-form .register-inner-form .form-input {
	padding: 10px 15px 10px 15px;
}
</style>